import React from 'react'
import Formulario from './Formulario'

const Contacto = () => {
  return (
    <section id='contacto' className="ds-section">
      <div className="ds-section-bg"></div>
      <div className="container py-5 position-relative">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-10 col-md-8">
            <span className="ds-eyebrow">Contacto</span>
            <h2 className='text-white mt-2 mb-3 ds-titulo'>
              Hablemos de tu <span className="ds-highlight">próximo proyecto</span>
            </h2>
            <p className="ds-lead mb-0">
              Contanos qué necesitás y te respondemos a la brevedad.
            </p>
          </div>
        </div>

        <div className="row justify-content-center align-items-stretch g-4">
          <div className="col-10 col-md-6 col-lg-5">
            <div className="ds-contacto-info">
              <a href="https://wa.link/e3tgkr" target="_blank" rel="noopener noreferrer" className="ds-contacto-item">
                <div className="ds-contacto-icon"><i className='bx bxl-whatsapp'></i></div>
                <div>
                  <div className="ds-contacto-label">WhatsApp</div>
                  <div className="ds-contacto-value">+595 973 192 211</div>
                </div>
                <i className='bx bx-right-arrow-alt ds-contacto-arrow'></i>
              </a>
              <a href="mailto:contacto@dscode.com.py" className="ds-contacto-item">
                <div className="ds-contacto-icon"><i className='bx bxl-gmail'></i></div>
                <div>
                  <div className="ds-contacto-label">Email</div>
                  <div className="ds-contacto-value">contacto@dscode.com.py</div>
                </div>
                <i className='bx bx-right-arrow-alt ds-contacto-arrow'></i>
              </a>
              <a href="https://www.instagram.com/dscode.py/" target="_blank" rel="noopener noreferrer" className="ds-contacto-item">
                <div className="ds-contacto-icon"><i className='bx bxl-instagram'></i></div>
                <div>
                  <div className="ds-contacto-label">Instagram</div>
                  <div className="ds-contacto-value">@dscode.py</div>
                </div>
                <i className='bx bx-right-arrow-alt ds-contacto-arrow'></i>
              </a>
            </div>
          </div>
          <div className="col-10 col-md-6 col-lg-6">
            <div className="ds-contacto-form-card">
              <Formulario />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contacto
